import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from "../context/AuthContext";

export default function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const cleanedEmail = email.trim(); // Remove spaces
      await register(name, cleanedEmail, password);
      navigate('/login');
    } catch (err) {
      setError(err.message.includes('email') 
        ? 'Please enter a valid email address' 
        : err.message || 'Registration failed');
    }
  };

  // Auto-trim on blur
  const handleEmailBlur = (e) => {
    setEmail(e.target.value.trim());
  };

  return (
    <div style={{
      maxWidth: '400px',
      margin: '2rem auto',
      padding: '2rem',
      background: '#1e293b',
      borderRadius: '8px'
    }}>
      <h2 style={{ color: 'white', textAlign: 'center' }}>Register</h2>
      {error && (
        <p style={{ 
          color: '#ef4444', 
          backgroundColor: '#fee2e2', 
          padding: '0.5rem',
          borderRadius: '4px',
          textAlign: 'center'
        }}>
          {error}
        </p>
      )}
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '1rem' }}>
          <label style={{ display: 'block', color: 'white', marginBottom: '0.5rem' }}>
            Full Name
          </label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={{ 
              width: '100%', 
              padding: '0.5rem',
              borderRadius: '4px',
              border: '1px solid #64748b',
              backgroundColor: '#1e293b',
              color: 'white' 
            }}
            required
          />
        </div>
        <div style={{ marginBottom: '1rem' }}>
          <label style={{ display: 'block', color: 'white', marginBottom: '0.5rem' }}>
            Email
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onBlur={handleEmailBlur} // Auto-trim on blur
            style={{ 
              width: '100%', 
              padding: '0.5rem',
              borderRadius: '4px',
              border: '1px solid #64748b',
              backgroundColor: '#1e293b',
              color: 'white'  
            }}
            required
          />
        </div>
        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{ display: 'block', color: 'white', marginBottom: '0.5rem' }}>
            Password (min. 6 characters)
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ 
              width: '100%', 
              padding: '0.5rem',
              borderRadius: '4px',
              border: '1px solid #64748b',
              backgroundColor: '#1e293b',
              color: 'white' 
            }}
            required
            minLength="6"
          />
        </div>
        <button 
          type="submit"
          style={{
            width: '100%',
            padding: '0.75rem',
            background: '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '1rem',
            fontWeight: '600',
            transition: 'background-color 0.2s',
          }}
        >
          Register
        </button>
      </form>
      <p style={{ 
        color: '#e2e8f0', 
        textAlign: 'center', 
        marginTop: '1.5rem',
        fontSize: '0.9rem'
      }}>
        Already have an account?{' '}
        <Link 
          to="/login" 
          style={{ 
            color: '#93c5fd',
            fontWeight: '500',
            textDecoration: 'none',
          }}
        >
          Log in now
        </Link>
      </p>
    </div>
  );
}
